module.exports = __webpack_public_path__ + "media/application/images/demo/main-060df2e8cde8e3e08014f82625556f77.jpg";